import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SettingWarningLabel = (props) => {
  if (!props.warning) return null;

  return (
    <div className="w-full setting-warning-label text-xl text-red-600 dark:text-red-400 mb-3">
      <FontAwesomeIcon icon="fas fa-exclamation-triangle" className="mr-5" />
      {props.warning}
    </div>
  );
};

export default SettingWarningLabel;
